import { useCallback, useEffect, useState } from 'react';

const useScrollAnimation = (options = {}) => {
  // Track the DOM node in state (via a callback ref) instead of useRef so the
  // observer is (re)attached whenever the element actually mounts — including
  // sections that render late, after their data has been fetched.
  const [element, setElement] = useState(null);
  const [isVisible, setIsVisible] = useState(false);

  const ref = useCallback((node) => setElement(node), []);

  const {
    threshold = 0.1,
    rootMargin = '0px 0px -50px 0px',
    triggerOnce = true,
  } = options;

  useEffect(() => {
    if (!element) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          if (triggerOnce) {
            observer.unobserve(element);
          }
        } else if (!triggerOnce) {
          setIsVisible(false);
        }
      },
      { threshold, rootMargin }
    );

    observer.observe(element);

    return () => observer.disconnect();
  }, [element, threshold, rootMargin, triggerOnce]);

  return { ref, isVisible };
};

export default useScrollAnimation;
